import { render, staticRenderFns } from "./ViewScopingDataExtraction.vue?vue&type=template&id=013d3c04"
import script from "./ViewScopingDataExtraction.vue?vue&type=script&lang=js"
export * from "./ViewScopingDataExtraction.vue?vue&type=script&lang=js"
import style0 from "./ViewScopingDataExtraction.vue?vue&type=style&index=0&id=013d3c04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports